import { jsx as a, jsxs as t, Fragment as M } from "react/jsx-runtime";
import { useCallback as v, useState as w, useEffect as W } from "react";
import { createPortal as S } from "react-dom";
import e from "./styles.module.less.js";
import { MenuItem as A } from "../menu-item/index.js";
import D from "../close.svg.js";
import R from "../chevron-right.svg.js";
import x from "../menu-dropdown-wrapper-mobile.svg.js";
import { useDisableScroll as B } from "../../../../utils/use-disable-scroll.js";
import { getRoute as g, RouteType as C } from "../../../../utils/get-route.js";
import T from "./get-help-ai-image.png.js";
import y from "./get-help-lawyer-image.png.js";
import { SlidingButton as u, SlidingButtonType as h } from "../../../general/sliding-button/index.js";
const K = (m) => {
  var s;
  const {
    isActive: N,
    hasShrunk: n,
    titleLabel: o,
    getTranslation: r,
    isLawyerSupported: l = !1,
    onRequestLawyer: i
  } = m, d = v(() => {
  }, []);
  return /* @__PURE__ */ a(
    A,
    {
      label: o ?? "",
      chevronStyle: "rotate",
      hasShrunk: n,
      isActive: N,
      onClick: d,
      classNames: {
        labelContainer: e.menuItemContainer,
        childContainer: e.menuItemDropdown
      },
      children: /* @__PURE__ */ a(
        "div",
        {
          className: `${e.innerWrapper} ${((s = m.classNames) == null ? void 0 : s.container) ?? ""}`,
          children: /* @__PURE__ */ t("div", { className: e.getHelpCardsContainer, children: [
            l && /* @__PURE__ */ t("div", { className: e.getHelpCard, children: [
              /* @__PURE__ */ t("div", { className: e.getHelpCardContent, children: [
                /* @__PURE__ */ a("h3", { className: e.getHelpCardTitle, children: r("pages.find-the-right-lawyer") }),
                /* @__PURE__ */ a("div", { className: e.getHelpCardCtaWrapper, children: /* @__PURE__ */ a(
                  u,
                  {
                    link: i ? void 0 : g(C.LAWYER_REQUEST_CHAT),
                    onClick: (c) => {
                      i && (c == null || c.preventDefault(), i());
                    },
                    text: r("pages.request-a-lawyer"),
                    buttonType: h.PURPLE,
                    classNames: {
                      buttonContainer: e.getHelpCardButton
                    }
                  }
                ) })
              ] }),
              /* @__PURE__ */ a("div", { className: e.getHelpCardImageWrapper, children: /* @__PURE__ */ a(
                "img",
                {
                  src: y,
                  alt: "Find the right lawyer",
                  className: e.getHelpCardImage
                }
              ) })
            ] }),
            /* @__PURE__ */ t("div", { className: e.getHelpCard, children: [
              /* @__PURE__ */ t("div", { className: e.getHelpCardContent, children: [
                /* @__PURE__ */ a("h3", { className: e.getHelpCardTitle, children: r("pages.get-ai-legal-answers") }),
                /* @__PURE__ */ a("div", { className: e.getHelpCardCtaWrapper, children: /* @__PURE__ */ a(
                  u,
                  {
                    link: g(C.NEW_CHAT),
                    text: r("pages.ask-a-question"),
                    buttonType: h.BLUE_MIDNIGHT,
                    classNames: {
                      buttonContainer: e.getHelpCardButton
                    }
                  }
                ) })
              ] }),
              /* @__PURE__ */ a("div", { className: e.getHelpCardImageWrapper, children: /* @__PURE__ */ a(
                "img",
                {
                  src: T,
                  alt: "Get AI legal answers",
                  className: e.getHelpCardImage
                }
              ) })
            ] })
          ] })
        }
      )
    }
  );
}, V = (m) => {
  const {
    titleLabel: N,
    getTranslation: n,
    onRequestLawyer: o,
    closeMenu: r,
    classNames: l,
    externalIsOpen: i,
    externalOnOpen: d,
    externalOnClose: s,
    hideDefaultTrigger: c = !1
  } = m, [k, f] = w(!1), [L, b] = w(!1), I = i !== void 0 ? i : k;
  B({ isDisabled: I });
  const E = v(() => {
    d ? d() : f(!0);
  }, [d]), p = v(() => {
    b(!0), setTimeout(() => {
      s ? s() : f(!1), b(!1), r();
    }, 150);
  }, [r, s]);
  return W(() => (window.addEventListener("resize", p), () => {
    window.removeEventListener("resize", p);
  }), [p]), /* @__PURE__ */ t(M, { children: [
    !c && /* @__PURE__ */ t("div", { className: e.headingContainer, onClick: E, children: [
      /* @__PURE__ */ a(
        "div",
        {
          className: `${e.mainMenuLink} ${(l == null ? void 0 : l.mainMenuLink) ?? ""}`,
          children: N
        }
      ),
      /* @__PURE__ */ a(R, { className: e.arrowIcon })
    ] }),
    I ? S(
      /* @__PURE__ */ t(
        "div",
        {
          className: `${e.areasMenuModal} ${l == null ? void 0 : l.container}`,
          children: [
            /* @__PURE__ */ a("div", { className: e.closeWrapper, children: /* @__PURE__ */ a(
              D,
              {
                className: `${e.closeButton} ${e.activeIcon} ${L ? e.hidden : ""}`,
                onClick: p
              }
            ) }),
            /* @__PURE__ */ a("div", { className: e.modalContent, children: /* @__PURE__ */ t("div", { className: e.getHelpCardsContainerMobile, children: [
              /* @__PURE__ */ a(M, { children: /* @__PURE__ */ t("div", { className: e.getHelpCardMobile, children: [
                /* @__PURE__ */ t("div", { className: e.getHelpCardContentMobile, children: [
                  /* @__PURE__ */ a("h3", { className: e.getHelpCardTitleMobile, children: n("pages.find-the-right-lawyer") }),
                  /* @__PURE__ */ a("div", { className: e.getHelpCardCtaWrapper, children: /* @__PURE__ */ a(
                    u,
                    {
                      link: o ? void 0 : g(C.LAWYER_REQUEST_CHAT),
                      onClick: (H) => {
                        o && (H == null || H.preventDefault(), o()), p();
                      },
                      text: n("pages.request-a-lawyer"),
                      buttonType: h.PURPLE,
                      classNames: {
                        buttonContainer: e.getHelpCardButton
                      }
                    }
                  ) })
                ] }),
                /* @__PURE__ */ a(
                  "img",
                  {
                    src: y,
                    alt: "Find the right lawyer",
                    className: e.getHelpCardImageMobile
                  }
                )
              ] }) }),
              /* @__PURE__ */ t("div", { className: e.getHelpCardMobile, children: [
                /* @__PURE__ */ t("div", { className: e.getHelpCardContentMobile, children: [
                  /* @__PURE__ */ a("h3", { className: e.getHelpCardTitleMobile, children: n("pages.get-ai-legal-answers") }),
                  /* @__PURE__ */ a("div", { className: e.getHelpCardCtaWrapper, children: /* @__PURE__ */ a(
                    u,
                    {
                      link: g(C.NEW_CHAT),
                      text: n("pages.ask-a-question"),
                      buttonType: h.BLUE_MIDNIGHT,
                      classNames: {
                        buttonContainer: e.getHelpCardButton
                      }
                    }
                  ) })
                ] }),
                /* @__PURE__ */ a(
                  "img",
                  {
                    src: T,
                    alt: "Get AI legal answers",
                    className: e.getHelpCardImageMobile
                  }
                )
              ] })
            ] }) }),
            /* @__PURE__ */ a(x, { className: e.mobileBGIcon })
          ]
        }
      ),
      document.body
    ) : null
  ] });
};
export {
  K as GetHelpMenuItemDesktop,
  V as GetHelpMenuItemMobile
};
